import {AsyncPipe} from '@angular/common';
import {NgModule} from '@angular/core';
import {ApiHelper} from '../services/api.helper';
import {PlaceService} from '../services/place.service';
import {ScraperService} from '../services/scraper.service';
import {UserService} from '../services/user.service';
import {WpService} from '../services/wp.service';
import {EmailBookingService} from '../services/email-booking.service';
import {CareproviderHelper} from '../services/careprovider.helper';
import {DoktorseReceptService} from '../services/doktorse-recept.service';
import {EnumsService} from '../services/enums.service';
import {LinkService} from '../services/link.service';
import {LoaderService} from '../services/loader.service';
import {ModalsControlService} from '../services/modals-control.service';
import {PluralService} from '../services/plural.service';
import {QuestionsService} from '../services/questions.service';
import {ReviewService} from '../services/review.service';
import {SeoMetaService} from '../services/seo-meta.service';
import {StorageService} from '../services/storage.service';
import {ToolsService} from '../services/tools.service';
import {UrlBuilderService} from '../services/url-builder.service';
import {TitleBuilderService} from '../services/title-builder.service';
// import {ConfigCatService} from '../services/config-cat.service';
import {DefaultValuesService} from '../services/default-values.service';
import {HeaderRedirectService} from '../services/header-redirect.service';
import {AdsStateService} from '../services/ads-state.service';
import {UrlValidatorService} from '../services/url-validator.service';
import {SearchHelperService} from '../services/search-helper.service';
import {CookieService} from 'ngx-cookie-service';
import {RedirectService} from '../services/redirect.service';
import {BookingHelperService} from '../services/booking-helper.service';
import {CaregiverService} from '../services/caregiver.service';
import {GtmService} from '../services/gtm.service';
import {LocalStateService} from '../modules/search/services/local-state.service';
import {RoutingParamsResolveService} from '../modules/search/services/routing-params-resolve.service';
import {StateValidatorService} from '../modules/search/services/state-validator.service';
import {NoScrollService} from '../services/no-scroll.service';
import {SessionService} from '../services/session.service';
import {PageViewsGa4ResolverService} from '../services/page-views-ga4-resolver.service';
import {GtmGa4EventPushService} from '../services/gtm-ga4-event-push.service';
import {StaticSidebarPuffsService} from '../services/static-sidebar-puffs.service';
import {WindowSizeService} from '../services/window-size.service';
import {SearchWidgetManagerService} from '../services/search-widget/search-widget-manager.service';
import {SearchWidgetFreeSearchResolverService} from '../services/search-widget/search-widget-free-search-resolver.service';
import {SearchWidgetUrlBuilderService} from '../services/search-widget/search-widget-url-builder.service';
import {MapsService} from '../services/maps.service';
import {AppConfigService} from '../services/app-config.service';
import {SearchService} from '../services/search/search.service';
import {SearchRoutingParamsResolveService} from '../services/search/search-routing-params-resolve.service';
import {SearchStateManagerService} from '../services/search/search-state-manager.service';
import {SearchDataManagerService} from '../services/search/search-data-manager.service';
import {SearchReloadService} from '../services/search/search-reload.service';
import {MyPagesService} from '../services/my-pages.service';
import {MailchimpService} from '../services/mailchimp.service';
import {ErrorReportService} from '../services/error-report.service';
import {StaticBlogService} from '../services/static-blog.service';
import {StaticNativesService} from '../services/static-natives.service';
import {StaticGuideService} from '../services/static-guide.service';
import {StaticPagesService} from '../services/static-pages.service';

@NgModule({
  declarations: [],
  imports: [],
  providers: [
    AppConfigService,
    ToolsService,
    DefaultValuesService,
    StorageService,
    SessionService,
    ApiHelper,
    AsyncPipe,
    LoaderService,
    LocalStateService,
    RoutingParamsResolveService,
    StateValidatorService,
    SeoMetaService,
    UrlBuilderService,
    SearchHelperService,
    // BlogService,
    WpService,
    PluralService,
    ModalsControlService,
    QuestionsService,
    // PagesService,
    EnumsService,
    LinkService,
    CareproviderHelper,
    ReviewService,
    EmailBookingService,
    DoktorseReceptService,
    TitleBuilderService,
    // GuideService,
    // NativesService,
    // ConfigCatService,
    HeaderRedirectService,
    AdsStateService,
    UserService,
    UrlValidatorService,
    ScraperService,
    CookieService,
    RedirectService,
    PlaceService,
    BookingHelperService,
    CaregiverService,
    GtmService,
    NoScrollService,
    PageViewsGa4ResolverService,
    GtmGa4EventPushService,
    StaticSidebarPuffsService,
    WindowSizeService,
    SearchWidgetFreeSearchResolverService,
    SearchWidgetManagerService,
    SearchWidgetUrlBuilderService,
    MapsService,
    MyPagesService,
    MailchimpService,
    SearchService,
    SearchStateManagerService,
    SearchRoutingParamsResolveService,
    SearchDataManagerService,
    SearchReloadService,
    ErrorReportService,
    StaticBlogService,
    StaticNativesService,
    StaticGuideService,
    StaticPagesService,
  ],
  bootstrap: [],
  exports: [],
})
export class CoreModule {}
